import { Avatar, Box, Tooltip, Typography } from "@mui/material";
import moment from "moment";
import { dateMonthYearFormatTime } from "../../constants";

const AuditPopover = ({ item, children, syncOnly = false }) => {
    return (
        <Tooltip
            placement="right"
            arrow
            enterDelay={100}
            leaveDelay={100}
            slotProps={{
                arrow: { sx: { color: "#fff" }, },
                tooltip: {
                    sx: { p: 1.5, width: 175, borderRadius: "5px", boxShadow: "0px 4px 12px rgba(0,0,0,0.15)", backgroundColor: "#fff", color: "#000", },
                }
            }}
            title={
                <Box>
                    {!syncOnly && (
                        <>
                            <Typography sx={{ fontSize: 13, fontWeight: 600 }}> Created By: </Typography>
                            <Box sx={{ display: "flex", gap: 1, alignItems: "center", mt: 0.5 }}>
                                <Avatar sx={{ width: 32, height: 32 }}> {String(item?.is_auto_generated ? "SPARTA" : item?.created_by?.name || "?").slice(0, 1)} </Avatar>
                                <Box>
                                    <Typography sx={{ fontSize: 11, fontWeight: 600 }}> {item?.is_auto_generated ? "Auto Generated by SPARTA" : item?.created_by?.name} </Typography>
                                    <Typography sx={{ fontSize: 10, color: "#bdbdbd" }}> {item?.created_at ? moment(item.created_at).format(dateMonthYearFormatTime) : "-"} </Typography>
                                </Box>
                            </Box>
                            {item?.updated_at && item?.updated_by?.name && (
                                <Box mt={1}>
                                    <Typography sx={{ fontSize: 13, fontWeight: 600 }}> Last Modified By: </Typography>
                                    <Box sx={{ display: "flex", gap: 1, alignItems: "center", mt: 0.5 }}>
                                        <Avatar sx={{ width: 32, height: 32 }}> {String(item.updated_by.name).slice(0, 1)} </Avatar>
                                        <Box>
                                            <Typography sx={{ fontSize: 11, fontWeight: 600 }}> {item.updated_by.name} </Typography>
                                            <Typography sx={{ fontSize: 10, color: "#bdbdbd" }}> {moment(item.updated_at).format(dateMonthYearFormatTime)} </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            )}
                        </>
                    )}
                    {item?.qb_last_sync_by?.name && (
                        <Box mt={syncOnly ? 0 : 1}>
                            <Typography sx={{ fontSize: 13, fontWeight: 600 }}>QB Last Synced By: </Typography>
                            <Box sx={{ display: "flex", gap: 1, alignItems: "center", mt: 0.5 }}>
                                <Avatar sx={{ width: 32, height: 32 }}> {String(item.qb_last_sync_by.name).slice(0, 1)} </Avatar>
                                <Box>
                                    <Typography sx={{ fontSize: 11, fontWeight: 600 }}> {item.qb_last_sync_by.name} </Typography>
                                    <Typography sx={{ fontSize: 10, color: "#bdbdbd" }}> {item?.qb_last_sync_time ? moment(item.qb_last_sync_time).format(dateMonthYearFormatTime) :item?.qb_last_sync_at ? moment(item.qb_last_sync_at).format(dateMonthYearFormatTime) : "--"} </Typography>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </Box>
            }>{children}</Tooltip>
    );
};
export default AuditPopover;